<template>
  <a :id="template.FileName + '_' + mediaClassification" :href="externalLink" target="new" :class="styleClasses" @contextmenu="contextMenu(template, $event)">
    <div class="item">
      <p><strong>{{ fileIconText(template.FileName) }}</strong></p>
      <p :title="template.FileName">{{ template.FileName }}</p>
    </div>
  </a>
</template>
<script>
import stringUtils from '@/utils/stringUtils'
import popupUtils from '@/utils/popupUtils'
import config from '../../configurations/config.js'

export default {
  name: 'projectDocumentBox',
  props: {
    options: {
      type: Object,
      required: true
    },
    template: {
      type: Object,
      required: false,
      default: () => ({})
    },
    mediaClassification: {
      type: String,
      required: false,
      default() {
        return config.constants.MediaClassification.ProjectDocuments
      }
    }
  },
  data() {
    return {
      styleClasses: '',
      externalLink: ''
    }
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler() {
        this.optionsChanged()
      }
    }
  },
  computed: {
    selectedElement: {
      set(value) {
        this.$store.commit('setSelectedElement', value)
      },
      get() {
        return this.$store.state.selectedElement
      }
    }
  },
  methods: {
    optionsChanged() {
      this.styleClasses = ''
      this.externalLink = ''
      let optionsObject = this.options || {}
      if (!optionsObject.externalLink || (optionsObject.externalLink && optionsObject.externalLink !== '')) {
        this.externalLink = `${optionsObject.externalLink}&preview=${encodeURIComponent(this.template.FileName)}`
      }

      if (optionsObject.enableBoxLink) {
        this.styleClasses += 'buttonClickEnabled'
      }
    },
    contextMenu: function (projectDocument, e) {
      this.selectedElement = {
        type: 'ATTACHMENT',
        id: 'attachement-' + projectDocument.FileName,
        fileName: projectDocument.FileName,
        mediaClassification: this.mediaClassification
      }
      popupUtils.popup(e, '#projectContextMenuPopup', { elementAnchor: 'rb', popupAnchor: 'cc' })
      e.preventDefault()
    },
    fileIconText: function (filename) {
      let fileExtension = stringUtils.getFileExtension(filename)
      switch (fileExtension) {
        case 'pdf':
          return 'PDF'
        case 'xlsx':
        case 'xlsm':
        case 'xls':
          return 'EXCEL'
        case 'doc':
        case 'docm':
        case 'docx':
        case 'dotm':
          return 'WORD'
        case 'txt':
          return 'T'
        case 'tif':
        case 'tiff':
          return 'G'
        case 'msg':
          return 'M'
        case 'dxf':
        case 'dwg':
          return 'DWG'
        case 'shp':
          return 'S'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.iconStyle {
  border: 1px solid;
  width: 20px;
  height: 20px;
  border-color: white;
  align-self: center;
}
</style>
